import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Shown in the file-list area when no files have been added yet.
 * Matches the Figma illustration: document icon with a spark, plus helper text.
 */
const EmptyUploadState: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      pt: '241px',
    }}
  >
    {/* Stacked icon: document + spark */}
    <Box sx={{ position: 'relative', mb: 0.5 }}>
      <img
        src="/images/license-files-upload.svg"
        alt="license-files-upload"
        width={35}
        height={42}
      />
    </Box>

    <Typography
      sx={{
        pt: '21px',
        fontSize: 14,
        fontWeight: 400,
        fontFamily: 'Poppins, sans-serif',
        color: '#8D9499',
        textAlign: 'center',
        maxWidth: 512,
        lineHeight: 1.6,
      }}
    >
      Files added here will be used to generate knowledge for the technology landscape
    </Typography>
  </Box>
);

export default EmptyUploadState;
